module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.maxPage) ? _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.switchToPage(1)
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-angle-double-left"
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.switchToPage(_vm.currentPage - 1)
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-angle-left"
  })]), _vm._v(" "), (_vm.showLeftEllipses) ? _c('li', [_vm._v("...")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.maxPage), function(pageNumber) {
    return (pageNumber >= _vm.minPageToShow && pageNumber <= _vm.maxPageToShow) ? _c('li', {
      class: {
        selected: pageNumber === _vm.currentPage
      },
      on: {
        "click": function($event) {
          _vm.switchToPage(pageNumber)
        }
      }
    }, [_vm._v(_vm._s(pageNumber))]) : _vm._e()
  }), _vm._v(" "), (_vm.showRightEllipses) ? _c('li', [_vm._v("...")]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.switchToPage(_vm.currentPage + 1)
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.switchToPage(_vm.maxPage)
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-angle-double-right"
  })])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c72b1cda!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Pagination.vue
// module id = 914
// module chunks = 2